import { useEffect, useState } from 'react';
// import { useParams } from 'react-router';
// import apiCall from '../../helpers/apifactory';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
// import TextField from "@mui/material/TextField";
// import DateFnsUtils from "@date-io/date-fns";
import MenuItem from "@mui/material/MenuItem";
// import { MuiPickersUtilsProvider, KeyboardDatePicker, } from "@material-ui/pickers";
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie'
import RateTariffComponent from "../common/RateTariffComponent";

const TcsKardo = () => {

  useEffect(()=>{
    let current_page = window.location.href.split('/').at(-1)
    setTimeout(()=>{
        document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }, 100)
})
window.addEventListener("scroll", function(event) {
    let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height+100;
      
        (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
}, false);  
window.addEventListener("scroll", function(event) {
    let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height+100;
        (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
       
}, false);  


  const [customer, setCustomer] = useState("");
  const [shipping, setShipping] = useState("");
  const [selectedSubCat, setSelectedSubCat] = useState("");
  // const [selectedProductType, setSelectedProductType] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [product2Dropdown, setProduct2Dropdown] = useState([]);
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies(['prodType', 'subCat'])

  // const handleDateChange = (date) => {
  //   setSelectedDate(date);
  // };

  // if (selectedSubCat ==="Overnights" || selectedSubCat === "2nd Day") navigate("/ecom");
  // else if (selectedDivision === "MMS") navigate("/mmsForm");
  // else if (selectedDivision === "Overland") navigate("/overland");
  const handleAccount = () => {
    if (selectedDivision === "Ecommerce" && selectedSubCat === "Overnight" || selectedSubCat === "2nd Day") navigate("/ecom");
    else if (selectedDivision === "Corporate" && selectedSubCat === "Overnight" || selectedSubCat === "2ndDay" ||
    selectedSubCat === "Products" || selectedSubCat === "Overland Express" || selectedSubCat === "Bulk") navigate("/corporate");
    // if (selectedDivision === "Ecommerce") navigate("/ecom");
    // else if (selectedDivision === "") navigate("/mmsForm");
    // else if (selectedDivision === "Overland") navigate("/overland");
    // else navigate("/corporate");
    else navigate("#");
  };

  // const param = {
  //   transdate: Moment(selectedDate).format("DDMMYYYY"),
  // };

  const [productType, setProductType] = useState({
    "General": [
      "Overnight",
      "2nd Day"
    ],
    "Sentiments": [
      "Products"
    ],
    "Overland": [
      "Overland Express"
    ]

    // "Courier Express": [
    //   "Overnight",
    //   "Economy 2nd Day Express – For more than 5 Kg parcels",
    //   "Overland Cargo For bulk parcels",
    //   "Int’l Courier",
    //   "Air Freight",
    //   "Air Cargo Airport To Airport",
    // ],
    // "E-Commerce Solutions": [
    //   "COD Express",
    //   "COD Overland",
    //   "Fulfillment Solution",
    // ],
    // "Sentiments Express": ["Gift Delivery"],
    // "Supply Chain Solutions": [],
    // "Warehousing & Transportation": ["Cold Chain", "Ambient"],
    // "Digital Transactional Printing": [],
    // "Bulk Distribution": [],
  });
  const productTypeCorp = {
    
    "Sentiments": [
      "Products"
    ],
    "Overland": [
      "Overland Express"
    ],
    "MMS": [
      "Bulk"
    ],
    "General": [
      "Overnight",
      "2ndDay"
    ],
  };
  const productTypeEcom = {
    "General": [
      "Overnight",
      "2nd Day"
    ],
    "Overland": [
      "Overland Express"
    ],
  };

  // const divisionDropdown = ['Corporate', 'Ecommerce', 'MMS', 'Overland']
  const divisionDropdown = ['Corporate', 'Ecommerce']

  const [productDropdown, setProductDropdown] = useState(
    Object.keys(productTypeCorp)
  );
  const productDropdownEcom = Object.keys(productTypeEcom);
  let [accountProd, setAccountProd] = useState("");

  const handleProduct = (e) => {
    console.log(e);
    e.target.value === "0"
      ? setProduct2Dropdown([])
      : setProduct2Dropdown(selectedDivision === 'Corporate' ? productTypeCorp[e.target.value] : productTypeEcom[e.target.value]);
    setAccountProd(e.target.value);
  };

  useEffect(() => {
    if (customer === "new")
      document.getElementById('new').scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, [customer])

  useEffect(() => {
    if (shipping)
      document.getElementById('shipping').scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, [shipping, selectedDivision])

  return (
    <div>
      <div className="bg-[#efefef] flex flex-col justify-center items-center h-[150px]">
        <h1 className="sm:text-[40px] text-[30px] font-bold ">TCS Kardo</h1>

      </div>

      <div className="my-[3rem]">
        <div className="flex flex-col justify-center items-center">

          <div className="flex gap-4 my-4 flex-wrap  ">
            <button
              onClick={() => setCustomer("new")}
              className="shadow-my-lg text-sm md:w-[22rem] sm:w-[20rem] w-[14rem] h-[3rem] hover:bg-[#F21E26] m-auto hover:text-white rounded-md transition-all duration-500"
            >
              New Customer
            </button>

            <a className="m-auto" href="/customer-portals">
              <button
                onClick={() => setCustomer("existing")}
                className="shadow-my-lg text-sm md:w-[22rem] sm:w-[20rem] w-[14rem] h-[3rem] hover:bg-[#F21E26] m-auto hover:text-white rounded-md transition-all duration-500"
              >
                Existing Customer
              </button>
            </a>

          </div>
        </div>
        {customer == "new" && (
          <div id='new'
            className="flex flex-col justify-center items-center ">
            <p>Single Shipment or Regular Shipping?</p>
            <div className="md:flex grid gap-4 my-4">
              <div className="flex flex-col gap-1 p-4 shadow-my-lg text-sm w-[22rem] h-[7.5rem]  rounded-md transition-all duration-500">
                <h2 className="font-bold text-[1.1rem]">Single Shipment</h2>
                <p>One Origin to One Destination</p>
                <button
                  onClick={() => setShipping("single")}
                  className="text-[#F21E26] border border-[#F21E26] w-full rounded-md mt-1 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
                >
                  Get a Quote
                </button>
              </div>
              <div className="flex flex-col gap-1 p-4 shadow-my-lg text-sm w-[22rem] h-[7.5rem]  rounded-md transition-all duration-500">
                <h2 className="font-bold text-[1.1rem]">Regular Shipping</h2>
                <p>Multiple Shipments, Origins and Destinations</p>
                <button
                  onClick={() => setShipping("regular")}
                  className="text-white bg-[#D40511] border border-[#F21E26] w-full rounded-md mt-1 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
                >
                  Open an Account
                </button>
              </div>
            </div>
          </div>
        )}

        {shipping == "single" && (
          <div id='shipping' className="flex flex-col justify-center items-center mt-[1rem]">
            <RateTariffComponent />
          </div>
        )}

        {shipping == "regular" && (
          <div id='shipping' className="flex flex-col justify-center items-center mt-[1rem] ">
            <div className="flex flex-col gap-3 p-4 shadow-my-lg text-sm lg:w-[45rem] md:w-[45rem] w-[22rem] rounded-md transition-all duration-500">
              <h2 className="font-bold text-[1.1rem]">
                Please Select a Segment
              </h2>
              <div className="flex gap-4">
                <div className="flex-1 flex flex-col">
                  <FormControl
                    variant="outlined"
                    className="flex-1"
                    size="small"
                    inputProps={{ style: { fontSize: 14 } }} // font size of input text
                    InputLabelProps={{ style: { fontSize: 14 } }} // font size of input label
                  >
                    <InputLabel
                      id="demo-simple-select-outlined-label"
                      style={{ fontSize: "14px !important" }}
                    >
                      Select a Segment
                    </InputLabel>
                    <Select
                      required
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      // value={age}
                      // onChange={handleProduct}
                      label="Select a Division"
                      inputProps={{ style: { fontSize: 14 } }} // font size of input text
                      InputLabelProps={{ style: { fontSize: 14 } }} // font size of input label
                    >
                      {divisionDropdown.map((product, index) => (
                        // <MenuItem key={index} value={product} onClick={() => setSelectedProductType(product)}>
                        <MenuItem key={index} value={product} onClick={() => {
                          setSelectedDivision(product)
                          console.log(product)
                          // setCookie('prodType', product, { path: '/' })
                        }}>
                          {product}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
              {selectedDivision && <>
                <h2 className="font-bold text-[1.1rem]">
                  Please Select a Product Type
                </h2>
                <div className="flex gap-4">
                  <div className="flex-1 flex flex-col">
                    <FormControl
                      variant="outlined"
                      className="flex-1"
                      size="small"
                      inputProps={{ style: { fontSize: 14 } }} // font size of input text
                      InputLabelProps={{ style: { fontSize: 14 } }} // font size of input label
                    >
                      <InputLabel
                        id="demo-simple-select-outlined-label"
                        style={{ fontSize: "14px !important" }}
                      >
                        Product Type
                      </InputLabel>
                      <Select
                        required
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        // value={age}
                        onChange={handleProduct}
                        label="Product Type"
                        inputProps={{ style: { fontSize: 14 } }} // font size of input text
                        InputLabelProps={{ style: { fontSize: 14 } }} // font size of input label
                      >
                        {selectedDivision === 'Corporate' ? productDropdown.map((product, index) => (
                          // <MenuItem key={index} value={product} onClick={() => setSelectedProductType(product)}>
                          <MenuItem key={index} value={product} onClick={() => setCookie('prodType', product, { path: '/' })}>
                            {product}
                          </MenuItem>
                        )) : productDropdownEcom.map((product, index) => (
                          // <MenuItem key={index} value={product} onClick={() => setSelectedProductType(product)}>
                          <MenuItem key={index} value={product} onClick={() => setCookie('prodType', product, { path: '/' })}>
                            {product}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="flex-1 flex flex-col">
                    {product2Dropdown.length !== 0 && (
                      <FormControl
                        variant="outlined"
                        className="flex-1"
                        size="small"
                        inputProps={{ style: { fontSize: 14 } }} // font size of input text
                        InputLabelProps={{ style: { fontSize: 14 } }} // font size of input label
                      >
                        <InputLabel
                          id="demo-simple-select-outlined-label"
                          style={{ fontSize: "14px !important" }}
                        >
                          Subcategory
                        </InputLabel>
                        <Select
                          required
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          // value={age}
                          // onChange={handleChange}
                          label="Subcategory"
                          inputProps={{ style: { fontSize: 14 } }} // font size of input text
                          InputLabelProps={{ style: { fontSize: 14 } }} // font size of input label
                        >
                          {product2Dropdown.map((product, index) => (
                            // <MenuItem key={index} value={product} onClick={() => setSelectedSubCategory(product)}>
                            <MenuItem key={index} value={product} onClick={() => 
                            // setCookie('subCat', product, { path: '/' })
                              setSelectedSubCat(product)
                            }>
                              {product}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </div>
                </div>
              </>}
              <button
                onClick={handleAccount}
                className="text-white bg-[#D40511] border border-[#F21E26] w-full rounded-md mt-1 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
              >
                Open an Account
              </button>

              {/* <Link href="/corporate" /> */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TcsKardo;
